import type { ComponentProps, ReactNode } from 'react';
import styled from 'styled-components';

import * as graphql from '@treams/treams-network';
import { Tooltip } from '@treams/treams-ui';

/**
 * The dark tooltip used throughout the talent review: labels, avatars, activity.
 * @param props tooltip props; `dark` is always set
 */
export function TalentReviewTooltip(props: Omit<ComponentProps<typeof Tooltip>, 'dark'>) {
	return <Tooltip dark {...props} />;
}

const AvatarTooltip = styled(TalentReviewTooltip)`
	display: flex;
	line-height: 0;
`;

export default function TalentReviewAvatarTooltip(props: {
	user: Pick<graphql.User, 'firstName' | 'lastName'>;
	enabled?: boolean;
	children: ReactNode;
}) {
	return (
		<AvatarTooltip
			content={`${props.user.firstName} ${props.user.lastName}`}
			enabled={props.enabled}
			position="top"
			fitContent
			portal
		>
			{props.children}
		</AvatarTooltip>
	);
}
